import React from "react";
import { createHashRouter } from "react-router-dom";
import ErrorBoundary from "./components/error-boundary";
import App from "./App";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Products from "./pages/Products";
import Solutions from "./pages/Solutions";
import Technology from "./pages/Technology";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Api from "@/pages/api";

const routerConfig = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/solutions",
    element: <Solutions />,
  },
  {
    path: "/technology",
    element: <Technology />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/api-doc",
    element: <Api />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

const router = createHashRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorBoundary />,
    children: routerConfig,
  },
]);

export default router;
